import { Subject, Case, } from "../../../Constant"
export const case_form_fields = [
    {
      id: 'subject',
      name: 'subject',
      label: `${Subject}`,
      type: 'text',
      value: '',
      required: true,
      colSize: 6,
    },
    {
      id: 'message',
      name: 'message',
      label: `${Case}`,
      type: 'joditEditor',
      //type: 'simpleEditor',
      //type: 'ckeditor',
      // type: 'textarea',
      value: '',
      required: true,
      colSize: 12,
    },
    
];

